// Copyright 2019 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { NavigationInstruction, Next, PipelineStep, Redirect, RedirectToRoute } from "aurelia-router";
import { RouteAuthorizationMode } from "catalogs/RouteConfigCatalog";
import { Status } from "datatypes/Status";
import { INotificationService, NotificationUrgency } from "services/Notification/INotificationService";
import { ServerStatus, IServerStatusService } from "services/Server/IServerStatusService";
import { WorkflowModeService } from "services/WorkflowModes/WorkflowModeService";

@autoinject
export class WorkflowModeStep implements PipelineStep {
    constructor(
        private readonly workflowModeService: WorkflowModeService,
        private readonly serverStatusService: IServerStatusService
    ) {}

    public async run(instruction: NavigationInstruction, next: Next): Promise<unknown> {
        if (
            instruction.config &&
            instruction.config.settings &&
            instruction.config.settings.needsWorkflowMode === false
        ) {
            // No workflowMode required
            return next();
        }

        if (this.workflowModeService.selectedWorkflowMode) {
            return next();
        }

        const selectedWorkflowMode = await this.workflowModeService.syncSelectedWorkflowModeFromStorage();
        if (selectedWorkflowMode) {
            return next();
        }

        // Redirect the user to the workflow mode selection screen
        const redirect = new RedirectToRoute("workflow_mode_selection");
        return next.cancel(redirect);
    }
}
